import React from 'react';
import { Mixpanel } from '../../redux/Mixpanel';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
    Input
} from 'reactstrap';
import {
    deleteProperty,
    deleteUnit,
    showLoading,
    fetchTeam,
    fetchPreferences,
    setDefaultPreferences,
    updatePreferences
} from '../../redux/actions';
import { colorTheme } from '../../utils/constants';
import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonHeader, IonLabel, IonMenuButton, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { Card } from '@tremor/react';



const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        tenants: state.tenants,
        preferences: state.preferences,
        user: state.user
    };
}

const mapDispatchToProps = {
    deleteProperty,
    deleteUnit,
    fetchTeam,
    showLoading,
    fetchPreferences,
    setDefaultPreferences,
    updatePreferences
};


class AlertSettings extends React.Component{
    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.renderHomePage = this.renderHomePage.bind(this);
        this.handleRestoreDefaultSettings = this.handleRestoreDefaultSettings.bind(this);
        this.handleSaveChanges = this.handleSaveChanges.bind(this);

        this.state = {
            propertyId: "",
            unitId: "",
            paymentAlerts: "",
            changesMade: false
        };
    }

    async componentDidMount(){
        if(_.isEmpty(this.props.preferences)){
            this.props.showLoading(true);
            await this.props.fetchPreferences();
        }
        let paymentAlerts = this.props.preferences.paymentAlerts;

        let newStates = {paymentAlerts};
        for (let item of Object.keys(this.props.preferences)){
            if (item !== "paymentAlerts"){
                for (let values of Object.values(this.props.preferences[item])){
                    newStates = {...newStates, [values.label]: values.value }
                }
            }
        }
        this.setState(newStates);
        // Mixpanel.track("AlertSettings tab: mounted");
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.preferences !== prevProps.preferences){
            let paymentAlerts = this.props.preferences.paymentAlerts;

            let newStates = {paymentAlerts, changesMade: false};
            for (let item of Object.keys(this.props.preferences)){
                if (item !== "paymentAlerts"){
                    for (let values of Object.values(this.props.preferences[item])){
                        newStates = {...newStates, [values.label]: values.value }
                    }
                }
            }
            this.setState(newStates);
        }
    }

    handleChange(event) {
        const target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({changesMade: true, [name]: val});
    }

    handleSaveChanges(){
        this.props.showLoading(true);
        this.props.updatePreferences({
            paymentAlerts: this.state.paymentAlerts,
            reports: this.receiveReportSettingToList(),
        })
        Mixpanel.track("AlertSettings tab: save btn");
    }

    receiveReportSettingToList(){
        let list = []
        for (let period of this.props.preferences.reports){
            this.state[period.label] && list.push((period.label).toLowerCase())
        }
        return list
    }

    handleRestoreDefaultSettings(){
        this.props.showLoading(true);
        this.props.setDefaultPreferences();
        Mixpanel.track("AlertSettings tab: restore defaults btn");
    }

    renderReceivePaymentAlerts(){
        return (
            <IonRow className="py-3">
                {/* section for payment alerts*/}
                <IonCol>
                    <IonLabel htmlFor="paymentAlerts">
                        Receive Payment Alerts
                    </IonLabel>
                    <Input
                        type="checkbox"
                        id="paymentAlerts"
                        name="paymentAlerts"
                        className='ml-2'
                        value={this.state.paymentAlerts}
                        checked={this.state.paymentAlerts}
                        onChange={this.handleChange}
                        data-testid="payment-alerts"

                    />
                </IonCol>
            </IonRow>
        );
    }

    renderReceiveReportsAlerts(){
        return (
            <IonRow className="py-3 border-bottom" style={{ display: "grid", gridTemplateRows: "min-content 1fr"}}>
                {/* section for payment reports - frequency*/}
                <IonCol>
                    <IonLabel>
                        Receive Reports
                    </IonLabel>
                </IonCol>

                <IonCol className="alert-report-columns">
                    {!_.isEmpty(this.props.preferences) && _.map(Object.values(this.props.preferences.reports), (preference, index) => (
                        <React.Fragment key={preference.label}>
                            <IonRow>
                                <Input
                                    type="checkbox"
                                    id={preference.label}
                                    name={preference.label}
                                    value={this.state[preference.label] ? this.state[preference.label] : false}
                                    checked={this.state[preference.label] ? this.state[preference.label] : false}
                                    onChange={this.handleChange}
                                    data-testid={`reports-${preference.label}`}
                                    className='mr-2'
                                />
                                <IonLabel>
                                    {preference.label}
                                </IonLabel>
                            </IonRow>
                        </React.Fragment>
                    ))}
                </IonCol>
            </IonRow>
        );
    }

    renderHomePage(){
        return (
            <Card>
                <div>
                    <IonRow>
                        <IonCol size="12">
                            {/* Receive Payment Alerts */}
                            {this.renderReceivePaymentAlerts()}

                            {/* Receive Reports */}
                            {this.renderReceiveReportsAlerts()}
                        </IonCol>
                    </IonRow>
                </div>

                <div className="ion-text-right">
                    <IonRow className="w-100 pt-3 mb-1 pb-3 ion-justify-content-center">
                        <IonButton
                            type="submit"
                            className="mx-2 mt-1 shadow"
                            color="primary"
                            onClick={this.handleRestoreDefaultSettings}
                        >
                            Restore Default Settings
                        </IonButton>
                    </IonRow>
                </div>
            </Card>
        )
    }

    render(){
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonMenuButton />
                        </IonButtons>
                        <IonTitle>Alerts</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    {this.renderHomePage()}
                </IonContent>
                <IonFooter>
                    <IonToolbar style={{ textAlign: "end"}}>
                    <IonButton
                            type="submit"
                            id="save-btn"
                            className="mx-4 mt-1 shadow"
                            color="primary"
                            disabled={!this.state.changesMade}
                            onClick={this.handleSaveChanges}
                            style={{ opacity: !this.state.changesMade ? '0.5' : '1' }}
                        >
                            Save Settings
                        </IonButton>
                    </IonToolbar>
                </IonFooter>
            </IonPage>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AlertSettings);